(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('SettingDialogController', SettingDialogController);

    SettingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Qinius', 'Backgrounds', 'MessageService',
    'Upload', 'UidService', 'ThemeClassify', 'Convert', '$localStorage'];

    function SettingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Qinius, Backgrounds, MessageService,
        Upload, UidService, ThemeClassify, Convert, $localStorage) {
        var vm = this;

        vm.type = entity.state;
        vm.attachments = [];
        vm.imgs = [];
        if(entity.state == 'add'){
            vm.data = {
                themeClassifyId: '',
                provider: 'qiniu',
                identifier: '',
                keys: [],
                type:'BG'
            }
        }
        ThemeClassify.getAllByCondition3({items:[{key: "used", op: "=", value: 'true'},{key: "type", op: "=", value: 'BG'}]},function (res) {
            if(res.status==200){
                vm.setting = res.data;
            }else{
                MessageService.error(res.message);
                return
            }
        });
        vm.domains = Qinius.getDomain();
        vm.cancel = cancel;
        vm.save = save;
        $q.all([vm.domains.$promise]).then(function(){
            // vm.domains = vm.domains.data;
             $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            if(entity.state != 'add'){
                Backgrounds.get({id: entity.data.id},function (res) {
                    if(res.status == 200){
                        vm.data = res.data;
                        console.log(vm.data)
                    }else{
                        MessageService.error(res.message);
                        return
                    }
                });
            }

        })

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });

        window.updateImgFile = function ($event) {
            $scope.$digest();
            $timeout(function () {
                for(var i=0;i<$event.target.files.length;i++){
                    var file = $event.target.files[i];
                    vm.imgs.push(file.name);
                    fileGet(file);
                }
                function fileGet(file) {
                    var formData = new FormData();
                    formData.append('file', file);
                    formData.append('unique_names', false);

                    formData.append('key', "clipArt-" + UidService.get());
                    formData.append('token', vm.token);
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: false,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            vm.attachments.push({identifier:data.key,fileName:vm.imgs[i]});
                            vm.data.keys.push(data.key);
                        },
                        error: function (request) {
                            MessageService.error("文件上传失败");
                        }
                    });

                }
            });
        }

        $scope.removeFile = function(file, index) {
            vm.attachments.splice(index, 1);
            vm.data.keys.splice(index, 1);
        };

        function cancel() {
            $uibModalInstance.close();
        }
        function save() {
            if(!vm.data.themeClassifyId){
                MessageService.error("请选择背景分类");
                return
            }
            if(!vm.data.seq){
                MessageService.error("请输入排序");
                return
            }
            if(vm.type == 'add'){
                if(vm.data.keys.length == 0){
                    MessageService.error("请选择背景图片");
                    return
                }
            }else{
                if(!vm.data.identifier){
                    MessageService.error("请选择背景图片");
                    return
                }
            }
            vm.isSaving = true;
            if (vm.data.id != null) {
                Backgrounds.update(vm.data, onSaveSuccess, onSaveError);
            } else {
                Backgrounds.batchCreateByStore(vm.data, onSaveSuccess, onSaveError);
            }
            function onSaveSuccess (result) {
                MessageService.success("背景保存成功");
                $uibModalInstance.close(result);
                vm.isSaving = false;
            };

            function onSaveError () {
                MessageService.error("背景保存失败");
                vm.isSaving = false;
            };
        }
    }
})();
